declare module 'react-bkoi-gl/styles' {
  const css: string;
  export default css;
}